import { BottomSheetChangeBreakpoint } from '../Modal';
import {
  CloseButton,
  GoBackButton,
  HeaderContainer,
  StyledChevronIcon,
  StyledCloseIcon,
  Title,
} from './ModalHeader.styles';

interface ModalHeaderProps {
  title?: string;
  centerTitle?: boolean;
  hideCloseButton?: boolean;
  /**
   * @description Should receive a valid CSS string.
   * @example "1rem 1.25rem 0 1rem"
   */
  mobileTitleMarginBottom?: string;
  onClose?: () => void;
  onGoBack?: () => void;
  bottomSheetChangeBreakpoint?: BottomSheetChangeBreakpoint;
}

const ModalHeader = ({
  title,
  centerTitle = false,
  hideCloseButton = false,
  mobileTitleMarginBottom,
  bottomSheetChangeBreakpoint,
  onClose,
  onGoBack = undefined,
}: ModalHeaderProps) => {
  return (
    <HeaderContainer $centerTitle={centerTitle}>
      {onGoBack !== undefined ? <GoBackButton icon={<StyledChevronIcon />} onClick={onGoBack} /> : <></>}
      <Title
        $mobileMarginBottom={mobileTitleMarginBottom}
        $goBackButtonIsVisible={onGoBack !== undefined}
        $bottomSheetChangeBreakpoint={bottomSheetChangeBreakpoint}
        $centerTitle={centerTitle}
      >
        {title}
      </Title>
      {!hideCloseButton && <CloseButton icon={<StyledCloseIcon />} onClick={onClose} />}
    </HeaderContainer>
  );
};

export default ModalHeader;
